const obj = {
  metaKey: "METAAPI_SKY_IN",
  upiDiscount: 100,
  creditCardDiscount: 0,
  debitCardDiscount: 0,
  netBankingDiscount: 0,
  payLaterDiscount: 0,
  walletDiscount: 0,
};
export const paymentFieldData = (data, metaData) => [
  {
    name: "metaKey",
    label: "Meta Key",
    value: data.metaKey,
    type: "autoSelect",
    placeHolder: "Enter Meta Key",
    options: metaData,
  },
  {
    name: "upiDiscount",
    label: "UPI Discount",
    value: data.upiDiscount,
    type: "number",
    placeHolder: "Enter UPI Discount",
  },
  {
    name: "creditCardDiscount",
    label: "Credit Card Discount",
    value: data.creditCardDiscount,
    type: "number",
    placeHolder: "Enter Credit Card Discount",
  },
  {
    name: "debitCardDiscount",
    label: "Debit Card Discount",
    value: data.debitCardDiscount,
    type: "number",
    placeHolder: "Enter Debit Card Discount",
  },
  {
    name: "netBankingDiscount",
    label: "Net Banking Discount",
    value: data.netBankingDiscount,
    type: "number",
    placeHolder: "Enter Net Banking Discount",
  },
  {
    name: "payLaterDiscount",
    label: "Pay Later Discount",
    value: data.payLaterDiscount,
    type: "number",
    placeHolder: "Enter Pay Later Discount",
  },
  {
    name: "walletDiscount",
    label: "Wallet Discount",
    value: data.walletDiscount,
    type: "number",
    placeHolder: "Enter Wallet Discount",
  },
];
